import { render, staticRenderFns } from "./ViewTask.vue?vue&type=template&id=2cccc789&"
import script from "./ViewTask.vue?vue&type=script&lang=js&"
export * from "./ViewTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports